// test896
(896 && 0);
